/** @format */

import {Button} from '@mui/material';
import {styled} from '@mui/material/styles';

const StyledButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.success.main,
  borderRadius: 8,
  color: theme.palette.text.primary,
  fontSize: 14,
  fontWeight: 700,
  height: 38,
  lineHeight: '18px',
  padding: '8px 16px',
  textTransform: 'none',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  '&:disabled': {
    backgroundColor: '#4D4D4D',
    color: '#DBDBDB',
    fontWeight: 400,
  },
  '&:hover': {
    backgroundColor: '#648F13',
  },
}));

export type PrimarySmallButtonProps = {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
};

const PrimarySmallButton = (props: PrimarySmallButtonProps) => (
  <StyledButton fullWidth={false} {...props} />
);

export default PrimarySmallButton;
